import { httpClient } from 'utils/httpClient';
import { getLocalRefreshToken } from 'utils/localStorage';

const URL = process.env.REACT_APP_API_URL;

export const signIn = ({
  login,
  password,
}: {
  login: string;
  password: string;
}) => {
  const url = `${URL}/api/login`;
  return httpClient.post(url, {
    login,
    password,
    returnSecureToken: true,
  });
};

export const refreshToken = async () => {
  const url = `${URL}/api/refresh`;

  const result = await httpClient.post(url, {
    refreshToken: getLocalRefreshToken(),
  });

  return result;
};

export const AuthService = {
  signIn,
  refreshToken,
};
